import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { CalendarProvider } from './contexts/CalendarContext';

// Components
import NavigationBar from './shared/NavigationBar';

// Pages
import FamilySpace from './pages/FamilySpace';

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <CalendarProvider>
          <Router>
            <div className="min-h-screen">
              <NavigationBar />
              <main className="pt-11">
                <Routes>
                  <Route path="/" element={<FamilySpace />} />
                  <Route path="/calendar" element={<FamilySpace />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </main>
            </div>
          </Router>
        </CalendarProvider>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
